export function verifyNewEpisodes(date, season_tmdb, season_db) {
    const releaseDate = new Date(date);
    const timestampLancamento = Math.floor(releaseDate.getTime() / 1000);

    const dataHoje = new Date();
    const timestampDataHoje = Math.floor(dataHoje.getTime() / 1000);

    // Calcular a diferença em segundos entre as datas
    const diffEmSegundos = timestampDataHoje - timestampLancamento;

    // Converter 2 semanas para segundos (14 dias * 24 horas * 60 minutos * 60 segundos)
    const duasSemanasEmSegundos = 14 * 24 * 60 * 60;

    const newSeason = diffEmSegundos < duasSemanasEmSegundos

    const showNewSeason = newSeason && (season_tmdb == season_db);

    return showNewSeason;
};